import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const dict = {
  en: {
    app_name: "",
    app_tagline: "",
    footer_internal_use: "Internal use only",
    nav_logout: "Log out",
    nav_lang_en: "EN",
    nav_lang_zh: "中文",
    login_heading: "Welcome back",
    login_subheading: "Sign in to manage your loan cases.",
    login_email: "Email",
    login_password: "Password",
    login_submit: "Sign in",
    login_google: "Continue with Google",
    login_or: "or",
    login_to_register: "Register as Agent",
    login_no_account: "Don't have an agent account?",
    register_heading: "Register as an Agent",
    register_subheading: "Submit your details. An admin will review and approve access.",
    register_name: "Full Name",
    register_email: "Work Email",
    register_password: "Password",
    register_agent_number: "Agent Number",
    register_phone: "Phone",
    register_submit: "Create Account",
    register_to_login: "Already have an account? Sign in",
    register_success_title: "Request submitted",
    register_success_body: "Your account is awaiting admin approval. You will be able to sign in once approved.",
    auth_callback_processing: "Completing sign-in…",
    auth_callback_pending: "Your account is awaiting admin approval.",
    auth_callback_back: "Back to sign in",
    admin_heading: "User Management",
    admin_subheading: "Approve agents, create reviewers, and control access.",
    admin_filter_search: "Search name, email, agent number…",
    admin_filter_role: "Role",
    admin_filter_status: "Status",
    admin_filter_all: "All",
    admin_create_reviewer: "Create Reviewer",
    admin_col_user: "User",
    admin_col_role: "Role",
    admin_col_status: "Status",
    admin_col_joined: "Joined",
    admin_col_actions: "Actions",
    admin_action_approve: "Approve",
    admin_action_disable: "Disable",
    admin_action_enable: "Enable",
    admin_action_change_role: "Change Role",
    admin_empty: "No users match your filters.",
    modal_create_reviewer_title: "Create a Reviewer",
    modal_create_reviewer_desc: "The reviewer will be active immediately and can log in with the credentials you set.",
    modal_name: "Full name",
    modal_email: "Email",
    modal_password: "Initial password",
    modal_cancel: "Cancel",
    modal_create: "Create reviewer",
    role_admin: "Admin",
    role_agent: "Agent",
    role_reviewer: "Reviewer",
    status_active: "Active",
    status_pending_approval: "Pending",
    status_disabled: "Disabled",
    agent_welcome: "Welcome, ",
    agent_phase2: "Cases are coming in Phase 2.",
    reviewer_welcome: "Welcome, ",
    reviewer_phase3: "The reviewer pool opens in Phase 3.",
    toast_language_updated: "Language updated",
    toast_approve_success: "User approved",
    toast_disable_success: "User disabled",
    toast_enable_success: "User enabled",
    toast_role_success: "Role updated",
    toast_reviewer_created: "Reviewer created",
    toast_signup_success: "Registration submitted — pending approval",
    err_generic: "Something went wrong. Please try again.",
    err_invalid_credentials: "Invalid email or password.",
    err_pending_approval: "Your account is pending admin approval.",
    err_disabled: "This account has been disabled.",
    // Phase 2 — Cases (chrome only; field labels are bilingual inline)
    nav_back: "Back",
    nav_my_cases: "My Cases",
    new_case: "New Case",
    agent_continue_draft_title: "Continue your last draft",
    agent_continue_draft_subtitle: "You have an unfinished case. Pick up where you left off.",
    agent_continue_draft_cta: "Continue",
    agent_my_cases: "My Cases",
    agent_no_cases: "You haven't created any cases yet. Click \"New Case\" to start.",
    agent_filter_all: "All",
    agent_filter_draft: "Draft",
    agent_filter_submitted: "Submitted",
    agent_filter_under_review: "Under Review",
    agent_table_applicant: "Applicant",
    agent_table_status: "Status",
    agent_table_updated: "Last Updated",
    agent_table_actions: "Actions",
    agent_action_edit: "Edit",
    agent_action_view: "View",
    agent_action_continue: "Continue",
    case_status_draft: "Draft",
    case_status_submitted: "Submitted",
    case_status_under_review: "Under Review",
    case_status_needs_correction: "Needs Correction",
    case_status_resubmitted: "Resubmitted",
    case_status_approved: "Approved",
    case_status_paid: "Paid",
    case_status_closed: "Closed",
    case_form_new_title: "New Case",
    case_form_edit_title: "Edit Case",
    case_form_view_title: "Case Details",
    case_form_section_applicant: "Applicant 贷款者",
    case_form_section_marital: "Marital Status 婚姻状况",
    case_form_section_spouse: "Spouse 配偶",
    case_form_section_health: "Health Status 健康状况",
    case_form_section_emergency: "Emergency Contact 紧急联系人",
    case_form_section_files: "Documents 文件上传",
    case_form_save_indicator_prefix: "Saved at ",
    case_form_saving: "Saving…",
    case_form_unsaved: "Unsaved changes",
    case_form_save_draft: "Save Draft",
    case_form_submit: "Submit Case",
    case_form_submitting: "Submitting…",
    case_form_view_back: "Back to dashboard",
    case_form_view_continue: "Continue Editing",
    case_form_marital_single: "Single 单身",
    case_form_marital_married: "Married 已婚",
    case_form_smoker_yes: "Yes 是",
    case_form_smoker_no: "No 否",
    case_form_upload: "Upload",
    case_form_uploading: "Uploading…",
    case_form_replace: "Replace",
    case_form_remove: "Remove",
    case_form_no_file: "No file uploaded",
    case_form_drop_or_click: "Click to upload — PDF / JPG / PNG, max 10 MB",
    case_form_required_label: "Required",
    case_form_optional_label: "Optional",
    case_form_add_other: "Add Document",
    case_form_other_description: "Description 描述",
    case_form_other_description_placeholder: "Describe this document",
    case_form_other_dialog_title: "Upload Other Document",
    case_form_other_dialog_desc: "Each additional document needs a short description so reviewers know what it is.",
    case_form_other_pick_file: "Choose file",
    case_form_invalid_submit: "Please fix the highlighted fields before submitting.",
    case_form_emergency_same: "Emergency contact cannot be the same person as the applicant.",
    toast_case_submitted: "Case submitted",
    toast_file_uploaded: "File uploaded",
    toast_file_removed: "File removed",
    err_file_too_large: "File too large (max 10 MB)",
    err_file_type: "File type not supported (PDF / JPG / PNG only)",
    err_case_not_editable: "This case can no longer be edited.",
    // Phase 3 — Reviewer pool, lifecycle, status thread
    reviewer_heading: "Reviewer Console",
    reviewer_subheading: "Claim cases from the pool and drive them to approval.",
    reviewer_tab_pool: "Pool 案件池",
    reviewer_tab_queue: "My Queue 我的队列",
    reviewer_stat_pool: "In Pool",
    reviewer_stat_queue: "My Queue",
    reviewer_stat_approved: "Approved this week",
    reviewer_pool_empty: "The pool is empty. Take a breather.",
    reviewer_queue_empty: "Nothing in your queue. Claim a case from Pool.",
    reviewer_table_applicant: "Applicant",
    reviewer_table_agent: "Agent",
    reviewer_table_submitted: "Submitted",
    reviewer_table_type: "Type",
    reviewer_table_status: "Status",
    reviewer_table_activity: "Last Activity",
    reviewer_table_actions: "Actions",
    reviewer_action_claim: "Claim",
    reviewer_action_open: "Open",
    reviewer_action_release: "Release back to pool",
    reviewer_action_correction: "Send back for correction",
    reviewer_action_approve: "Approve",
    reviewer_action_close: "Close case",
    agent_action_resubmit: "Resubmit",
    agent_filter_needs_correction: "Needs Correction",
    agent_filter_resubmitted: "Resubmitted",
    agent_filter_approved: "Approved",
    agent_filter_closed: "Closed",
    agent_action_required: "Action required",
    case_lifecycle_assigned_to: "Assigned to",
    case_lifecycle_unclaimed: "Awaiting reviewer",
    case_lifecycle_pool: "This case is in the pool. Anyone can claim it.",
    case_lifecycle_under_review: "Under review by",
    case_lifecycle_needs_correction: "Reviewer asked for changes — please update and resubmit.",
    case_lifecycle_resubmitted: "Resubmitted. Reviewer is checking the changes.",
    case_lifecycle_approved: "Approved.",
    case_lifecycle_closed: "Case closed.",
    case_lifecycle_draft: "Draft — fill in the form and submit when ready.",
    case_lifecycle_submitted: "Submitted. Awaiting reviewer.",
    status_thread_title: "Status & Remarks 状态与备注",
    status_thread_empty: "No activity yet.",
    status_thread_comment_placeholder: "Add a comment…",
    status_thread_send: "Send",
    status_thread_locked: "Comments are disabled on closed cases.",
    correction_dialog_title: "Send back for correction",
    correction_dialog_desc: "Tell the agent what needs to be fixed.",
    correction_dialog_label: "Message to agent",
    correction_dialog_placeholder: "Please update the mailing address…",
    approve_dialog_title: "Approve case",
    approve_dialog_desc: "Optionally include a note for the agent.",
    approve_dialog_label: "Optional note",
    close_dialog_title: "Close case",
    close_dialog_desc: "Closing the case marks it as final. This cannot be undone.",
    confirm_close: "Close case",
    confirm_release: "Release",
    event_type_comment: "Comment",
    event_type_status_change: "Status changed",
    event_type_claim: "Claimed",
    event_type_release: "Released",
    event_type_file_change: "File updated",
    toast_claimed: "Case claimed",
    toast_released: "Case released",
    toast_correction_sent: "Sent back to agent",
    toast_resubmitted: "Case resubmitted",
    toast_approved: "Case approved",
    toast_closed: "Case closed",
    toast_comment_sent: "Comment posted",
    err_already_claimed: "Sorry, another reviewer just claimed this case.",
    err_correction_message_required: "Please write a short message for the agent.",
    // Phase 4 — Notifications + Admin Cases
    nav_notifications: "Notifications",
    notif_mark_all_read: "Mark all as read",
    notif_view_all: "View all",
    notif_empty: "No notifications yet",
    notif_filter_all: "All",
    notif_filter_unread: "Unread",
    notif_today: "Today",
    notif_yesterday: "Yesterday",
    notif_earlier: "Earlier",
    admin_tab_users: "Users",
    admin_tab_cases: "Cases",
    admin_cases_heading: "All Cases",
    admin_cases_search: "Search by applicant name, email, or phone…",
    admin_cases_filter_status: "Status",
    admin_cases_filter_agent: "Agent",
    admin_cases_filter_reviewer: "Reviewer",
    admin_cases_filter_unassigned: "Unassigned",
    admin_cases_stat_total: "Total",
    admin_cases_stat_pool: "In Pool",
    admin_cases_stat_review: "Under Review",
    admin_cases_stat_approved: "Approved",
    admin_cases_stat_closed: "Closed",
    admin_cases_col_applicant: "Applicant",
    admin_cases_col_agent: "Agent",
    admin_cases_col_reviewer: "Reviewer",
    admin_cases_col_status: "Status",
    admin_cases_col_submitted: "Submitted",
    admin_cases_col_updated: "Updated",
    admin_cases_action_open: "Open",
    admin_cases_action_force_release: "Force Release",
    admin_cases_action_reassign: "Reassign Reviewer",
    admin_cases_action_close: "Close case",
    force_release_dialog_title: "Force release case",
    force_release_dialog_desc: "This removes the current reviewer's assignment and returns the case to the pool. The reviewer will be notified.",
    force_release_confirm: "Force release",
    reassign_dialog_title: "Reassign reviewer",
    reassign_dialog_desc: "Pick another active reviewer to handle this case. They will be notified.",
    reassign_select_label: "Reviewer",
    reassign_confirm: "Reassign",
    toast_force_released: "Case released back to pool",
    toast_reassigned: "Case reassigned",
    // Phase 5 — Audit log + admin sort + extra event types
    audit_log_title: "Audit Log 审计记录",
    event_type_reassign: "Reassigned",
    admin_cases_col_created: "Created",
    admin_cases_sort_asc: "Sort ascending",
    admin_cases_sort_desc: "Sort descending",
    admin_cases_no_match: "No cases match your filters.",
    notif_caught_up: "You're all caught up.",
    // Phase 6 — Human Case # + Rejected outcome
    case_number_label: "Case #",
    case_number_short: "Case 案件",
    case_status_in_pool: "In Pool",
    case_status_resubmitted_short: "Resubmitted",
    case_status_rejected: "Rejected",
    case_lifecycle_rejected: "This case was rejected.",
    reviewer_action_approve_loan: "Approve Loan",
    reviewer_action_reject_loan: "Reject Loan",
    reject_dialog_title: "Reject Loan",
    reject_dialog_desc: "Provide an optional reason. The agent will be notified and the case can later be closed.",
    reject_dialog_label: "Reject reason",
    reject_dialog_placeholder: "Why is this loan being rejected? (optional)",
    reject_confirm: "Reject Loan",
    toast_rejected: "Loan rejected",
    agent_filter_rejected: "Rejected",
    admin_cases_stat_rejected: "Rejected",
    case_search_placeholder: "Jump to Case # (e.g. 042)",
    case_search_not_found: "No matching case",
    // Phase 7 — PDF + Bundle ZIP export
    download_pdf: "Download PDF",
    download_bundle: "Download All",
    export_disabled_draft: "Submit the case to enable export.",
    toast_pdf_downloaded: "PDF downloaded",
    toast_bundle_downloaded: "Bundle downloaded",
    // Reviewer queue filter chips (Phase 9 bug fix)
    reviewer_filter_active:   "Active",
    reviewer_filter_approved: "Approved",
    reviewer_filter_paid:     "Paid",
    reviewer_filter_rejected: "Rejected",
    reviewer_filter_closed:   "Closed",
    reviewer_filter_all:      "All",
    reviewer_stat_closed_week: "Closed this week 本周结案",
    // Phase 10 — Profile / Password / Bank Details
    profile: "Profile",
    account: "Account",
    security: "Security",
    bank_details: "Bank Details",
    current_password: "Current Password",
    new_password: "New Password",
    confirm_password: "Confirm New Password",
    change_password: "Change Password",
    set_password: "Set Password",
    password_min_8: "Password must be at least 8 characters",
    password_mismatch: "Passwords do not match",
    password_same_as_current: "New password must be different from the current password",
    incorrect_current_password: "Incorrect current password",
    password_updated: "Password updated",
    bank_name: "Bank Name",
    account_name: "Account Name",
    account_number: "Account Number",
    bank_helper: "Admins use these details to send your payment after a case is approved.",
    bank_locked: "You cannot change bank details while a case is awaiting payment.",
    not_provided: "Not provided",
    reviewer_bank_missing_warn: "Reviewer hasn't set bank details yet.",
    reviewer_bank_block_title: "Reviewer Bank Details",
    google_only_password_notice: "Set a password to log in with email + password too.",
    toast_saved: "Saved",
    save: "Save",
    // Phase 9 — Payment flow + simplified lifecycle
    case_status_paid_to_reviewer: "Paid to Reviewer",
    case_status_repayment_submitted: "Repayment Submitted",
    case_lifecycle_paid_to_reviewer: "Reviewer paid. Awaiting agent's repayment slip.",
    case_lifecycle_repayment_submitted: "Repayment slip submitted. Admin will close after verification.",
    case_lifecycle_locked_post_submit: "Case is locked after submission. Reviewer is in charge.",
    // Phase 12 — Simplified agent-driven payment flow
    case_lifecycle_approved_agent: "Approved — upload the customer payment slip, then tap Mark Paid.",
    case_lifecycle_paid: "Customer payment received. Admin will confirm and close.",
    case_lifecycle_paid_admin: "Agent marked the customer as paid. Review the slip and close the case.",
    payment_section_title: "Customer Payment 客户付款",
    payment_customer_slip: "Customer Payment Slip 客户付款凭证",
    payment_customer_slip_help_agent: "Upload the proof that the customer paid you, then tap Mark Paid.",
    payment_customer_slip_help_others: "Agent will upload proof of customer payment here.",
    payment_paid_admin: "Slip is uploaded. Close the case when you've confirmed payment.",
    payment_paid_other: "Marked as paid by the agent. Awaiting admin to close.",
    payment_mark_paid: "Mark Paid 标记已付款",
    payment_mark_reviewer_paid: "Mark Reviewer Paid",
    payment_submit_repayment: "Submit Repayment",
    payment_admin_close: "Confirm Payment & Close 确认并结案",
    payment_reviewer_no_access: "This document is not shared with reviewers.",
    payment_requires_slip: "Upload the customer payment slip first.",
    payment_reviewer_slip_help: "Admin uploads the receipt for the payment made to the reviewer.",
    payment_agent_slip_help: "Agent uploads the repayment slip after admin marks reviewer paid.",
    payment_awaiting_admin: "Awaiting admin to mark reviewer paid.",
    payment_awaiting_agent: "Awaiting agent's repayment slip.",
    payment_done: "Case closed. Payment flow complete.",
    toast_marked_paid: "Marked as paid",
    toast_reviewer_paid: "Marked reviewer as paid",
    toast_repayment_submitted: "Repayment slip submitted",
    err_post_submit_lock: "Case is locked. No edits allowed after submission.",
    agent_filter_paid: "Paid",
    admin_cases_stat_paid: "Paid",
    // Phase 13 — admin password reset + forced change
    reset_password: "Reset Password",
    reset_password_confirm: "This will generate a new temporary password for {name}. The current password will stop working immediately.",
    temp_password_modal_title: "Temporary Password Generated",
    temp_password_modal_helper: "Share this with {name} securely (call, WhatsApp, or in person). They will be required to set a new password on first login.",
    temp_password_shown_once: "This password is shown only once.",
    copy: "Copy",
    copied: "Copied",
    password_change_required: "Password change required",
    password_change_required_body: "An admin generated a temporary password for you. Please set a new password before continuing.",
    set_new_to_continue: "Set a new password to continue",
    notif_type_password_reset: "Password reset",
    temp_password_ok_button: "Got it",
    // Phase 14 — Re-submit for Edit + pending_re_edit
    pending_re_edit_label: "Pending Re-Edit",
    pending_re_edit_agent_banner: "This case is awaiting re-edit. Please update the details and click Submit to send it back to review.",
    pending_re_edit_admin_banner: "Awaiting agent re-edit.",
    pending_re_edit_reviewer_banner: "Case has been resubmitted for edit. It will return to the pool after the agent submits.",
    resubmit_for_edit: "Re-submit for Edit",
    resubmit_for_edit_title: "Re-submit Case for Edit",
    resubmit_for_edit_helper: "This will move the case back to Pending Re-Edit so the agent can update the data and re-attach files. The current approval, reviewer assignment, and any payment slip will be cleared.",
    resubmit_for_edit_reason: "Reason",
    resubmit_for_edit_reason_placeholder: "e.g., Customer changed project",
    toast_resubmitted_for_edit: "Case sent back for re-edit",
    case_form_resubmit: "Re-submit Case",
    storage_cleanup: "Run Storage Cleanup",
    storage_cleanup_helper: "Scan for file records whose bytes are missing from storage. Dry-run first — review the list, then click Apply to null the affected slots and notify the agents to re-upload.",
    storage_cleanup_apply: "Apply Cleanup",
    return_for_correction: "Return for Correction",
    return_for_correction_title: "Return Case for Correction",
    return_for_correction_helper: "The case will be sent back to the agent so they can update missing details or documents. Reviewer assignment will be cleared and the case will return to the Pool after the agent re-submits.",
    return_for_correction_reason_placeholder: "e.g., Missing CTOS report",
    home: "Home",
    download_file: "Download",
    err_file_not_found: "File no longer available",
    err_file_forbidden: "You do not have permission to download this file",
    err_server: "Server error — please try again or contact support",


    case_status_pending_re_edit: "Pending Re-Edit",
    agent_filter_pending_re_edit: "Pending Re-Edit",
    admin_cases_stat_pending_re_edit: "Pending Re-Edit",
  },
  zh: {
    app_name: "",
    app_tagline: "",
    footer_internal_use: "内部使用",
    nav_logout: "退出登录",
    nav_lang_en: "EN",
    nav_lang_zh: "中文",
    login_heading: "欢迎回来",
    login_subheading: "登录以管理您的贷款案件。",
    login_email: "邮箱",
    login_password: "密码",
    login_submit: "登录",
    login_google: "使用 Google 登录",
    login_or: "或者",
    login_to_register: "注册为专员",
    login_no_account: "还没有专员账户?",
    register_heading: "注册为专员",
    register_subheading: "提交您的信息,管理员审核通过后即可登录。",
    register_name: "姓名",
    register_email: "工作邮箱",
    register_password: "密码",
    register_agent_number: "专员编号",
    register_phone: "手机号码",
    register_submit: "创建账户",
    register_to_login: "已有账户?立即登录",
    register_success_title: "提交成功",
    register_success_body: "您的账户正在等待管理员审核,审核通过后即可登录。",
    auth_callback_processing: "正在完成登录…",
    auth_callback_pending: "您的账户正在等待管理员审核。",
    auth_callback_back: "返回登录页",
    admin_heading: "用户管理",
    admin_subheading: "审批专员、创建审核员并管理访问权限。",
    admin_filter_search: "搜索姓名、邮箱或专员编号…",
    admin_filter_role: "角色",
    admin_filter_status: "状态",
    admin_filter_all: "全部",
    admin_create_reviewer: "创建审核员",
    admin_col_user: "用户",
    admin_col_role: "角色",
    admin_col_status: "状态",
    admin_col_joined: "创建时间",
    admin_col_actions: "操作",
    admin_action_approve: "批准",
    admin_action_disable: "停用",
    admin_action_enable: "启用",
    admin_action_change_role: "更改角色",
    admin_empty: "没有符合筛选条件的用户。",
    modal_create_reviewer_title: "创建审核员",
    modal_create_reviewer_desc: "审核员创建后即可使用设置的凭据登录。",
    modal_name: "姓名",
    modal_email: "邮箱",
    modal_password: "初始密码",
    modal_cancel: "取消",
    modal_create: "创建审核员",
    role_admin: "管理员",
    role_agent: "专员",
    role_reviewer: "审核员",
    status_active: "已启用",
    status_pending_approval: "待审批",
    status_disabled: "已停用",
    agent_welcome: "欢迎, ",
    agent_phase2: "案件功能将在第二阶段上线。",
    reviewer_welcome: "欢迎, ",
    reviewer_phase3: "审核池将在第三阶段开放。",
    toast_language_updated: "语言已更新",
    toast_approve_success: "用户已批准",
    toast_disable_success: "用户已停用",
    toast_enable_success: "用户已启用",
    toast_role_success: "角色已更新",
    toast_reviewer_created: "审核员已创建",
    toast_signup_success: "提交成功,正在等待审批",
    err_generic: "出现问题,请稍后再试。",
    err_invalid_credentials: "邮箱或密码错误。",
    err_pending_approval: "您的账户正在等待管理员审批。",
    err_disabled: "该账户已被停用。",
    // Phase 2 — Cases (chrome only)
    nav_back: "返回",
    nav_my_cases: "我的案件",
    new_case: "新建案件",
    agent_continue_draft_title: "继续您的草稿",
    agent_continue_draft_subtitle: "您有一份未完成的案件,可以继续编辑。",
    agent_continue_draft_cta: "继续编辑",
    agent_my_cases: "我的案件",
    agent_no_cases: "您还没有创建任何案件。点击 \"新建案件\" 开始。",
    agent_filter_all: "全部",
    agent_filter_draft: "草稿",
    agent_filter_submitted: "已提交",
    agent_filter_under_review: "审核中",
    agent_table_applicant: "贷款者",
    agent_table_status: "状态",
    agent_table_updated: "最近更新",
    agent_table_actions: "操作",
    agent_action_edit: "编辑",
    agent_action_view: "查看",
    agent_action_continue: "继续",
    case_status_draft: "草稿",
    case_status_submitted: "已提交",
    case_status_under_review: "审核中",
    case_status_needs_correction: "需要修改",
    case_status_resubmitted: "已重新提交",
    case_status_approved: "已批准",
    case_status_closed: "已关闭",
    case_status_paid: "已付款",
    case_form_new_title: "新建案件",
    case_form_edit_title: "编辑案件",
    case_form_view_title: "案件详情",
    case_form_section_applicant: "Applicant 贷款者",
    case_form_section_marital: "Marital Status 婚姻状况",
    case_form_section_spouse: "Spouse 配偶",
    case_form_section_health: "Health Status 健康状况",
    case_form_section_emergency: "Emergency Contact 紧急联系人",
    case_form_section_files: "Documents 文件上传",
    case_form_save_indicator_prefix: "已保存于 ",
    case_form_saving: "保存中…",
    case_form_unsaved: "尚未保存",
    case_form_save_draft: "保存草稿",
    case_form_submit: "提交案件",
    case_form_submitting: "提交中…",
    case_form_view_back: "返回工作台",
    case_form_view_continue: "继续编辑",
    case_form_marital_single: "Single 单身",
    case_form_marital_married: "Married 已婚",
    case_form_smoker_yes: "Yes 是",
    case_form_smoker_no: "No 否",
    case_form_upload: "上传",
    case_form_uploading: "上传中…",
    case_form_replace: "替换",
    case_form_remove: "移除",
    case_form_no_file: "尚未上传文件",
    case_form_drop_or_click: "点击上传 — PDF / JPG / PNG, 最大 10 MB",
    case_form_required_label: "必填",
    case_form_optional_label: "可选",
    case_form_add_other: "添加文件",
    case_form_other_description: "Description 描述",
    case_form_other_description_placeholder: "请简要说明这份文件",
    case_form_other_dialog_title: "上传其他文件",
    case_form_other_dialog_desc: "每份附加文件都需要一段简短描述,以便审核员了解文件内容。",
    case_form_other_pick_file: "选择文件",
    case_form_invalid_submit: "提交前请修正高亮的字段。",
    case_form_emergency_same: "紧急联系人不能与贷款者本人相同。",
    toast_case_submitted: "案件已提交",
    toast_file_uploaded: "文件已上传",
    toast_file_removed: "文件已移除",
    err_file_too_large: "文件过大(最大 10 MB)",
    err_file_type: "不支持的文件类型(仅支持 PDF / JPG / PNG)",
    err_case_not_editable: "该案件已无法编辑。",
    // Phase 3 — Reviewer pool, lifecycle, status thread
    reviewer_heading: "审核员工作台",
    reviewer_subheading: "从案件池接案,推动案件直到批准。",
    reviewer_tab_pool: "Pool 案件池",
    reviewer_tab_queue: "My Queue 我的队列",
    reviewer_stat_pool: "案件池",
    reviewer_stat_queue: "我的队列",
    reviewer_stat_approved: "本周已批准",
    reviewer_stat_closed_week: "本周结案",
    reviewer_filter_active: "进行中",
    reviewer_filter_approved: "已批准",
    reviewer_filter_paid: "已付款",
    reviewer_filter_rejected: "已拒绝",
    reviewer_filter_closed: "已结案",
    reviewer_filter_all: "全部",
    // Phase 10 — Profile / Password / Bank Details (zh)
    profile: "个人资料",
    account: "账户",
    security: "安全",
    bank_details: "银行信息",
    current_password: "当前密码",
    new_password: "新密码",
    confirm_password: "确认新密码",
    change_password: "修改密码",
    set_password: "设置密码",
    password_min_8: "密码至少需要 8 位",
    password_mismatch: "两次输入的密码不一致",
    password_same_as_current: "新密码不能与当前密码相同",
    incorrect_current_password: "当前密码不正确",
    password_updated: "密码已更新",
    bank_name: "银行名称",
    account_name: "账户名",
    account_number: "账号",
    bank_helper: "管理员将根据这些信息向您转账。",
    bank_locked: "有案件正在等待付款,暂时无法修改银行信息。",
    not_provided: "未填写",
    reviewer_bank_missing_warn: "审核员尚未填写银行信息。",
    reviewer_bank_block_title: "审核员银行信息",
    google_only_password_notice: "设置密码后即可使用邮箱+密码登录。",
    toast_saved: "已保存",
    save: "保存",
    reviewer_pool_empty: "案件池暂无任务,稍作休息。",
    reviewer_queue_empty: "您的队列暂无任务,可从案件池接案。",
    reviewer_table_applicant: "贷款者",
    reviewer_table_agent: "专员",
    reviewer_table_submitted: "提交时间",
    reviewer_table_type: "类型",
    reviewer_table_status: "状态",
    reviewer_table_activity: "最近活动",
    reviewer_table_actions: "操作",
    reviewer_action_claim: "接案",
    reviewer_action_open: "打开",
    reviewer_action_release: "释放回案件池",
    reviewer_action_correction: "退回修正",
    reviewer_action_approve: "批准",
    reviewer_action_close: "结案",
    agent_action_resubmit: "重新提交",
    agent_filter_needs_correction: "需要修改",
    agent_filter_resubmitted: "已重新提交",
    agent_filter_approved: "已批准",
    agent_filter_closed: "已结案",
    agent_action_required: "需要处理",
    case_lifecycle_assigned_to: "已指派给",
    case_lifecycle_unclaimed: "等待审核员",
    case_lifecycle_pool: "该案件在案件池中,审核员可以接案。",
    case_lifecycle_under_review: "正在审核 ·",
    case_lifecycle_needs_correction: "审核员请求修改,请更新后重新提交。",
    case_lifecycle_resubmitted: "已重新提交,审核员正在查看。",
    case_lifecycle_approved: "已批准。",
    case_lifecycle_closed: "案件已结案。",
    case_lifecycle_draft: "草稿 — 填好表单后提交。",
    case_lifecycle_submitted: "已提交,等待审核员处理。",
    status_thread_title: "Status & Remarks 状态与备注",
    status_thread_empty: "暂无活动。",
    status_thread_comment_placeholder: "添加评论…",
    status_thread_send: "发送",
    status_thread_locked: "已结案的案件不接受新评论。",
    correction_dialog_title: "退回修正",
    correction_dialog_desc: "请说明需要修改的内容,以便专员了解。",
    correction_dialog_label: "给专员的留言",
    correction_dialog_placeholder: "请更新书信地址……",
    approve_dialog_title: "批准案件",
    approve_dialog_desc: "可选填一条说明给专员。",
    approve_dialog_label: "备注(可选)",
    close_dialog_title: "结案",
    close_dialog_desc: "结案会将案件标记为最终状态,无法撤销。",
    confirm_close: "结案",
    confirm_release: "释放",
    event_type_comment: "评论",
    event_type_status_change: "状态变更",
    event_type_claim: "接案",
    event_type_release: "释放",
    event_type_file_change: "文件更新",
    toast_claimed: "已接案",
    toast_released: "已释放",
    toast_correction_sent: "已退回给专员",
    toast_resubmitted: "已重新提交",
    toast_approved: "已批准",
    toast_closed: "已结案",
    toast_comment_sent: "评论已发送",
    err_already_claimed: "抱歉,该案件已被其他审核员接走。",
    err_correction_message_required: "请填写简短的留言给专员。",
    // Phase 4 — Notifications + Admin Cases
    nav_notifications: "通知",
    notif_mark_all_read: "全部标记为已读",
    notif_view_all: "查看全部",
    notif_empty: "暂无通知",
    notif_filter_all: "全部",
    notif_filter_unread: "未读",
    notif_today: "今天",
    notif_yesterday: "昨天",
    notif_earlier: "更早",
    admin_tab_users: "用户",
    admin_tab_cases: "案件",
    admin_cases_heading: "全部案件",
    admin_cases_search: "搜索贷款者姓名、邮箱或电话…",
    admin_cases_filter_status: "状态",
    admin_cases_filter_agent: "专员",
    admin_cases_filter_reviewer: "审核员",
    admin_cases_filter_unassigned: "未指派",
    admin_cases_stat_total: "全部",
    admin_cases_stat_pool: "案件池",
    admin_cases_stat_review: "审核中",
    admin_cases_stat_approved: "已批准",
    admin_cases_stat_closed: "已结案",
    admin_cases_col_applicant: "贷款者",
    admin_cases_col_agent: "专员",
    admin_cases_col_reviewer: "审核员",
    admin_cases_col_status: "状态",
    admin_cases_col_submitted: "提交时间",
    admin_cases_col_updated: "更新时间",
    admin_cases_action_open: "打开",
    admin_cases_action_force_release: "强制释放",
    admin_cases_action_reassign: "重新指派审核员",
    admin_cases_action_close: "结案",
    force_release_dialog_title: "强制释放案件",
    force_release_dialog_desc: "此操作会移除当前审核员并将案件返回案件池。审核员将收到通知。",
    force_release_confirm: "强制释放",
    reassign_dialog_title: "重新指派审核员",
    reassign_dialog_desc: "选择一位活跃审核员处理此案件。新审核员将收到通知。",
    reassign_select_label: "审核员",
    reassign_confirm: "重新指派",
    toast_force_released: "案件已释放回案件池",
    toast_reassigned: "案件已重新指派",
    // Phase 5 — Audit log + admin sort + extra event types
    audit_log_title: "Audit Log 审计记录",
    event_type_reassign: "已重新指派",
    admin_cases_col_created: "创建时间",
    admin_cases_sort_asc: "升序",
    admin_cases_sort_desc: "降序",
    admin_cases_no_match: "没有符合筛选条件的案件。",
    notif_caught_up: "您已查看完所有通知。",
    // Phase 6 — Human Case # + Rejected outcome
    case_number_label: "案件编号",
    case_number_short: "案件 Case",
    case_status_in_pool: "案件池",
    case_status_resubmitted_short: "已重新提交",
    case_status_rejected: "已拒绝",
    case_lifecycle_rejected: "此案件已被拒绝。",
    reviewer_action_approve_loan: "批准贷款",
    reviewer_action_reject_loan: "拒绝贷款",
    reject_dialog_title: "拒绝贷款",
    reject_dialog_desc: "可填写拒绝理由(可选)。专员将收到通知,案件之后可结案。",
    reject_dialog_label: "拒绝原因",
    reject_dialog_placeholder: "为什么拒绝此贷款?(可选)",
    reject_confirm: "拒绝贷款",
    toast_rejected: "贷款已拒绝",
    agent_filter_rejected: "已拒绝",
    admin_cases_stat_rejected: "已拒绝",
    case_search_placeholder: "跳至案件编号(例如 042)",
    case_search_not_found: "未找到匹配的案件",
    // Phase 7 — PDF + Bundle ZIP export
    download_pdf: "下载 PDF",
    download_bundle: "下载全部",
    export_disabled_draft: "提交后即可导出。",
    toast_pdf_downloaded: "PDF 已下载",
    toast_bundle_downloaded: "压缩包已下载",
    // Phase 9 — Payment flow + simplified lifecycle
    case_status_paid_to_reviewer: "已付审核员",
    case_status_repayment_submitted: "还款已提交",
    case_lifecycle_paid_to_reviewer: "已付款给审核员。等待专员上传还款凭证。",
    case_lifecycle_repayment_submitted: "还款凭证已提交,管理员确认后将结案。",
    case_lifecycle_locked_post_submit: "案件提交后已锁定,由审核员处理。",
    // Phase 12 — Simplified agent-driven payment flow
    case_lifecycle_approved_agent: "已批准 — 上传客户付款凭证后点击 \"标记已付款\"。",
    case_lifecycle_paid: "已收到客户付款,等待管理员确认并结案。",
    case_lifecycle_paid_admin: "专员已标记客户付款,请确认后结案。",
    payment_section_title: "客户付款 Customer Payment",
    payment_customer_slip: "客户付款凭证 Customer Payment Slip",
    payment_customer_slip_help_agent: "上传客户付款凭证,然后点击 \"标记已付款\"。",
    payment_customer_slip_help_others: "专员将在此上传客户付款凭证。",
    payment_paid_admin: "凭证已上传。确认付款无误后请结案。",
    payment_paid_other: "专员已标记为已付款,等待管理员结案。",
    payment_mark_paid: "标记已付款 Mark Paid",
    payment_mark_reviewer_paid: "标记已付审核员",
    payment_submit_repayment: "提交还款凭证",
    payment_admin_close: "确认并结案 Confirm & Close",
    payment_reviewer_no_access: "审核员无法查看此文件。",
    payment_requires_slip: "请先上传客户付款凭证。",
    payment_reviewer_slip_help: "管理员上传付款给审核员的收据。",
    payment_agent_slip_help: "审核员收款后,专员上传还款凭证。",
    payment_awaiting_admin: "等待管理员标记已付审核员。",
    payment_awaiting_agent: "等待专员上传还款凭证。",
    payment_done: "案件已结案,付款流程已完成。",
    toast_marked_paid: "已标记为已付款",
    toast_reviewer_paid: "已标记审核员已付款",
    toast_repayment_submitted: "还款凭证已提交",
    err_post_submit_lock: "案件已锁定,提交后不可编辑。",
    agent_filter_paid: "已付款",
    admin_cases_stat_paid: "已付款",
    // Phase 13 — admin password reset + forced change
    reset_password: "重置密码",
    reset_password_confirm: "这将为 {name} 生成临时密码,当前密码将立即失效。",
    temp_password_modal_title: "临时密码已生成",
    temp_password_modal_helper: "请安全地告知 {name}(电话、WhatsApp 或当面)。该用户首次登录时将被要求设置新密码。",
    temp_password_shown_once: "此密码仅显示一次。",
    copy: "复制",
    copied: "已复制",
    password_change_required: "需要修改密码",
    password_change_required_body: "管理员为您生成了临时密码,请先设置新密码。",
    set_new_to_continue: "请先设置新密码",
    notif_type_password_reset: "密码已重置",
    temp_password_ok_button: "我已知晓",
    // Phase 14 — Re-submit for Edit + pending_re_edit
    pending_re_edit_label: "待重新提交",
    pending_re_edit_agent_banner: "此案件待重新修改,请更新资料后点击「提交」重新进入审核。",
    pending_re_edit_admin_banner: "等待申请方修改。",
    pending_re_edit_reviewer_banner: "案件已退回修改,申请方提交后将重新进入案件池。",
    resubmit_for_edit: "重新提交修改",
    resubmit_for_edit_title: "重新提交案件以修改",
    resubmit_for_edit_helper: "此操作将案件退回至「待重新提交」,由申请方更新资料并重新上传。当前的批准、审核员分配及付款凭证将被清除。",
    resubmit_for_edit_reason: "原因",
    resubmit_for_edit_reason_placeholder: "例:客户更改了项目",
    toast_resubmitted_for_edit: "案件已退回修改",
    case_form_resubmit: "重新提交案件",
    storage_cleanup: "运行存储清理",
    storage_cleanup_helper: "扫描已丢失字节的文件记录。建议先预览,确认无误后再点击应用以清空对应栏位并通知专员重新上传。",
    storage_cleanup_apply: "应用清理",
    return_for_correction: "退回修正",
    return_for_correction_title: "退回案件修正",
    return_for_correction_helper: "此操作将案件退回给申请方以补充资料或文件。审核员分配将被清除,待申请方重新提交后将回到案件池。",
    return_for_correction_reason_placeholder: "例:缺少 CTOS 报告",
    download_file: "下载",
    err_file_not_found: "文件已不可用",
    err_file_forbidden: "您无权下载此文件",
    err_server: "服务器错误,请稍后重试或联系支持",

    home: "主页",
    case_status_pending_re_edit: "待重新提交",
    agent_filter_pending_re_edit: "待重新提交",
    admin_cases_stat_pending_re_edit: "待重新提交",
  },
};

const LanguageContext = createContext({
  language: "en",
  t: (k) => k,
  setLanguage: () => {},
});

export const LanguageProvider = ({ children, initial = "en" }) => {
  const [language, setLanguageState] = useState(initial);

  const setLanguage = useCallback((lang) => {
    if (lang === "en" || lang === "zh") {
      setLanguageState(lang);
      try {
        localStorage.setItem("crm_lang", lang);
      } catch {
        /* ignore */
      }
    }
  }, []);

  const t = useCallback(
    (key) => {
      const table = dict[language] || dict.en;
      return table[key] ?? dict.en[key] ?? key;
    },
    [language]
  );

  const value = useMemo(() => ({ language, setLanguage, t }), [language, setLanguage, t]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);

export const getInitialLanguage = () => {
  try {
    const stored = localStorage.getItem("crm_lang");
    if (stored === "en" || stored === "zh") return stored;
  } catch {
    /* ignore */
  }
  return "en";
};
